/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useForm, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, Box, Checkbox, Divider, FormControlLabel, FormLabel, IconButton, TextField, Chip } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useSelector } from 'react-redux';
import type { BrandApiResponse1, BrandListPropType, RootState, appConfigs } from '../types/types';
import { getAllBrand } from 'src/services/brandService';
import { getAllGroup } from 'src/services/groupService';
import { getAlltemplate } from 'src/services/templateService';
import { getCampaignDetailsById, updateNewCampaign } from 'src/services/campaignService';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { BRAND_TOOLTIP, BRAND_TOOLTIP_MESSAGE, BULK_CLIENT_CAMPAIGN_ID, CAMPAIGN_EDITING_DISABLED_MESSAGE, CAMPAIGN_NAME_TOOLTIP, CAMPAIGN_NAME_TOOLTIP_MESSAGE, COOLDOWN_PERIOD_TOOLTIP, COOLDOWN_PERIOD_TOOLTIP_MESSAGE, ERR_EMAIL, ERR_EMAIL_INVALID, GROUP_TOOLTIP, GROUP_TOOLTIP_MESSAGE, MAXIMUM_RESEND_TOOLTIP, MAXIMUM_RESEND_TOOLTIP_MESSAGE, RESEND_INTERVAL_TOOLTIP, RESEND_INTERVAL_TOOLTIP_MESSAGE, SEND_TEST_EMAIL, UNKNOWN_ERR, UNSUBSCRIBE_LEVELS } from 'src/constants/constant';
import SendTestEmail from '../SendTestEmail/SendTestEmail';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';

import InputAdornment from '@mui/material/InputAdornment';
//@ts-ignore
import { HelpCircleIcon } from '@hugeicons-pro/core-stroke-rounded';
import * as EmailValidator from 'email-validator';
import { checkEventPermission } from 'src/common/utility/utility';
import { getAllSuppressionListByClientId } from "src/services/suppressionListService";
import { getCampaignESPConnections, getESPConnectionData } from 'src/services/emailAPIESPServices';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

export interface NewCampaignInputs {
    campaignId?: number;
    clientId?: number;
    groupId?: string | null;
    brandId?: string | null;
    templateId: string;
    espConnectionId: string;
    espDomain?: string | null;
    templateIdentifier?: string;
    name: string;
    description?: string;
    startOn: string;
    endOn: string;
    updatedBy?: number;
    unopenedResendDayGap?: number | null;
    resendMaxLimit?: number;
    doNotRepeatEmailDays?: number;
    hourlyMaxSendCount?: number;
    dailyMaxSendCount?: number;
    emailSendStartTime?: string;
    emailSendEndTime?: string;
    isActive?: boolean;
    unsubscribeTypeId?: string;
    suppressionListId?: string[] | string | null;
    clientCampaignId?: string | null;


}

interface GroupListPropType {
    "id": number;
    "clientId": number;
    "clientName": string;
    "groupName": string;
    "isDeleted": boolean;
    "createdBy": number;
    "createdByUserName": string;
    "createdOn": string;
    "modifiedBy": number;
    "modifiedOn": string;
    "modifiedByUserName": string;
    "cooldownPeriod": number;
}

interface GroupApiResponse {
    status: number;
    data: {
        data: GroupListPropType[];
        result: number;
    };
}

interface TemplateListPropType {
    id: number;
    litmusId?: number;
    parentId?: number;
    createdBy?: number;
    clientId?: number;
    templateName: string;
    templateContent: string;
    templateIdentifier?: string;
    subjectLine: string;
    fromName: string;
    fromEmail: string;
    preheader: string;
    resendSubjectLine: string;
    resendPreheader: string;
    status: number;
    templateVersion: number;
}

interface TemplateApiResponse {
    status: number;
    data: {
        data: TemplateListPropType[];
        result: number;
    };
}

interface ApiResponse {
    status: number;
    data: {
        data: NewCampaignInputs[];
    };
}

interface SuppressionListPropType {
  suppressionList: any;
  suppressionListData: any[];
}

interface SuppressionApiResponse {
  status: number;
  data: {
    data: SuppressionListPropType[];
    result: number;
  };
}

const EditCampaing: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [brands, setBrands] = useState<any>([])
    const [groups, setGroups] = useState<any>([])
    const [emailTemplates, setEmailTemplates] = useState<any>([])
    const [campaignData, setCampaignData] = useState<any>()
    const [espConnectionData, setESPConnectionData] = useState<any>([])
    const [selectedGroup, setSelectedGroup] = useState<GroupListPropType | null>(null);
    const [cooldownPeriod, setCooldownPeriod] = useState<number | null>(null);
    const [isCooldownDisabled, setIsCooldownDisabled] = useState<boolean>(false);
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState<TemplateListPropType | null>(null);
    const [previewContent, setPreviewContent] = useState<string>("");
    const storedAppConfig = localStorage.getItem("appConfigs");
    const [imageError, setImageError] = useState(false);
    const [suppressionList, setSuppressionList] = useState<any[]>([]);
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : []; // Default to an empty array if null

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    const ResendMaxValue: any = parsedAppConfig.find(
        (item) => item.configType === "CampaignSettings" && item.configName === "ResendMaxValue"
    )?.configValue;

    const ResendDefaultValue = parsedAppConfig.find(
        (item) => item.configName === "ResendDefaultValue")?.configValue;

    const ResendMaxInterval = parsedAppConfig.find(
        (item) => item.configName === "ResendMaxInterval")?.configValue;

    const ResendDefaultInterval = parsedAppConfig.find(
        (item) => item.configName === "ResendDefaultInterval")?.configValue;

    const CooldownMaxPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownMaxPeriod")?.configValue;

    const CooldownDefaultPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownDefaultPeriod")?.configValue;

    const engageBeUrl = parsedAppConfig.find(
        (item) => item.configType === 'EngageApp' && item.configName === 'BaseURLBE'
    )?.configValue ?? '';

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Campaign name required"),
        startOn: Yup.string().required("Campaign start date required")
            .test("valid-date", "Invalid date format", (value) =>
                moment(value, "MM/DD/YYYY", true).isValid()
            ),
        endOn: Yup.string().required("Campaign end date required")
            .test("valid-date", "Invalid date format", (value) =>
                moment(value, "MM/DD/YYYY", true).isValid()
            )
            .test("endAfterStart", "End date must be after start date", function (value) {
                const { startOn } = this.parent;
                return moment(value, "MM/DD/YYYY").isSameOrAfter(moment(startOn, "MM/DD/YYYY"));
            }),
        templateId: Yup.string().required("Please select email template"),
        resendMaxLimit: Yup.number().typeError("Value must be a number").min(0, "Value cannot be negative").max(ResendMaxValue ? parseInt(ResendMaxValue, 10) : 3, "Value cannot be greater than " + (ResendMaxValue ? ResendMaxValue : 3)),
        doNotRepeatEmailDays: Yup.number().typeError("Value must be a number").min(1, "Value should be greater than 0").max(CooldownMaxPeriod ? parseInt(CooldownMaxPeriod, 10) : 30, "Value cannot be greater than " + (CooldownMaxPeriod ? CooldownMaxPeriod : 30)),
        unopenedResendDayGap: Yup.number()
                    .nullable()
                    .transform((value, originalValue) =>
                        String(originalValue).trim() === '' ? null : value
                    )
                    .typeError("Value must be a number")
                    .when('resendMaxLimit', {
                        is: (val:any) => val > 0,
                        then: (schema) =>
                        schema
                            .required("Resend interval is required")
                            .min(1, "Value should be greater than 0")
                            .max(
                            ResendMaxInterval ? parseInt(ResendMaxInterval, 10) : 14,
                            `Value cannot be greater than ${ResendMaxInterval ? parseInt(ResendMaxInterval, 10) :  14}`
                            ),
                        otherwise: (schema) => schema.notRequired().nullable(),
                    }),
        espConnectionId: Yup.string().required("Please select a domain name"),
        clientCampaignId: Yup.string()
            .max(100, 'Client Campaign ID cannot exceed 100 characters')
            .notRequired(),
        // unsubscribeTypeId: Yup.string().required("Please select unsubscribe level"),
    });
    
    const hasPermission = !!checkEventPermission('CAMPAIGN_UPDATE'); 
    const isActive = campaignData?.isActive === true || campaignData?.isCampaignInUse === true;
    const isAdmin = !!checkEventPermission('CAMPAIGN_EDIT_ACTIVE');
    const isDisabled = campaignData?.isProcessing === true || !hasPermission ||  (!isAdmin && isActive)   
    console.log("isDisabled", isDisabled, hasPermission, isActive, isAdmin);
    const [showUpdateCampaignModal, setShowUpdateCampaignModal] = useState<boolean>(false);
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
      '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
      },
      '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
      },
    }));

    const param = useParams();

    const { id } = param;

    const navigate = useNavigate()

    const { user } = useSelector((state: RootState) => state.auth);

    const {
        control,
        handleSubmit,
        setValue,
        trigger,
        getValues,
        formState: { errors },
    } = useForm<NewCampaignInputs>({
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        fetchCampaingData()
    }, [id])

    const fetchCampaingData = async (): Promise<void> => {
        setIsDataLoading(true)
        try {
            const campaignId: any = id;
            if (campaignId === null) return;
            // setIsLoading(true)
            const res: any = await getCampaignDetailsById(campaignId);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (res.status === 200 && res.data.data.length > 0) {
                const campaign = res.data.data[0]; // Access the first brand in the array
                setCampaignData(campaign);
                const startDate = moment(campaign.startOn).format('MM/DD/YYYY');
                const endDate = moment(campaign.endOn).format('MM/DD/YYYY');
                // Set form values
                setValue("name", campaign.name);
                setValue("startOn", startDate);
                setValue("endOn", endDate);
                setValue("brandId", campaign.brandId)
                setValue("groupId", campaign.groupId)
                setValue("templateId", campaign.templateId)
                setValue("resendMaxLimit", campaign.resendMaxLimit)
                setValue("unopenedResendDayGap", campaign.unopenedResendDayGap)
                setValue("isActive", campaign.isActive)
                const unsubscribeLevel = UNSUBSCRIBE_LEVELS.find(
                (level) => level.value === String(campaign.unsubscribeTypeId)
                );
                setValue("unsubscribeTypeId", unsubscribeLevel?.value ?? "");
                setValue("clientCampaignId", campaign.clientCampaignId || "")
                setValue("espConnectionId", campaign.espConnectionId ? String(campaign.espConnectionId) : "")
                setValue("espDomain", campaign.espDomain ?? null)
                getTemplateData(campaign.templateId)
                

                // Fetch groups and then check for cooldown period
                const ClientId = user?.clientId ?? 0;
                const groupResponse: GroupApiResponse = await getAllGroup(ClientId);
                if (groupResponse.status === 200 && groupResponse.data.result === 1) {
                    const webhookArr: GroupListPropType[] = groupResponse.data.data.map((webhook: any) => ({
                        ...webhook, // Keep existing properties
                        Name: webhook.clientName, // Assign Name from clientName
                        cooldownPeriod: webhook.cooldownPeriod, // Ensure cooldownPeriod is assigned correctly
                    }));
                    setGroups(webhookArr);

                    // Check if the selected group has a cooldown period
                    const selectedGroup = webhookArr.find((group: GroupListPropType) => group.id === campaign.groupId);
                    console.log(selectedGroup);
                    if (selectedGroup?.cooldownPeriod !== undefined && selectedGroup?.cooldownPeriod !== null) {
                        setCooldownPeriod(selectedGroup.cooldownPeriod);
                        setIsCooldownDisabled(true);
                        // If cooldownPeriod exists, set doNotRepeatEmailDays to cooldownPeriod
                        setValue("doNotRepeatEmailDays", selectedGroup.cooldownPeriod);
                    } else {
                        setCooldownPeriod(0);
                        setIsCooldownDisabled(false);
                        // Otherwise, use campaign.doNotRepeatEmailDays
                        setValue("doNotRepeatEmailDays", campaign.doNotRepeatEmailDays);
                    }
                } else {
                    setGroups([]);
                    // Ensure doNotRepeatEmailDays is set if no groups are available
                    setValue("doNotRepeatEmailDays", campaign.doNotRepeatEmailDays);
                }
                // fetch suppression list
                const suppressionResponse: SuppressionApiResponse =
                    await getAllSuppressionListByClientId(ClientId);

                if (
                    suppressionResponse.status === 200 &&
                    suppressionResponse.data.result === 1
                ) {
                    const suppressionArr = suppressionResponse.data.data.map((item: any) => ({
                    suppressionListId: item.suppressionList.suppressionListId,
                    title: item.suppressionList.title,
                    suppressionType: item.suppressionList.suppressionType,
                    itemCount: item.suppressionList.itemCount,
                    }));

                    setSuppressionList(suppressionArr);

                    if (campaign.suppressionListId) {
                    const ids = String(campaign.suppressionListId)
                        .split(",")
                        .map((id) => id.trim())
                        .filter(Boolean);
                        setValue("suppressionListId", ids);
                    } else {
                        setValue("suppressionListId", []); 
                    }
                } else {
                    setSuppressionList([]);
                }
            }
        } catch (error) {
            console.error("Error fetching brand data:", error);
        } finally {
            setIsDataLoading(false)
            setIsLoading(false)
        }
    }
useEffect(() => {
  setImageError(false);
}, [selectedTemplate?.templateIdentifier]);
    const getTemplateData = (tempId: number): void => {
        const ClientId = user?.clientId ?? 0;
        getAlltemplate(ClientId)
        .then(
            (res: TemplateApiResponse) => {
                if (res.status === 200) {
                    const templateArr = res.data.data
                        .filter((template: any) =>
                            template.statusName === "Approved" && template.isDeleted !== 1
                        ) // Filter only Approved templates and exclude deleted ones
                        .map((template: any) => ({
                            ...template,
                            Name: template.templateName // Assign templateName to Name
                        }))
                        .sort((a, b) => a.Name.localeCompare(b.Name));

                    setEmailTemplates(templateArr);
                    const filtered = templateArr.filter(item => item.id === tempId);

                    setSelectedTemplate(filtered[0]);
                    setPreviewContent("content")
                }
            })
        .catch(
            (error: any) => console.log("Error: ", error)
        )
    }

    useEffect(() => {
        const ClientId = user?.clientId ?? 0;

        Promise.all([getCampaignESPConnections(engageBeUrl, ClientId), getESPConnectionData()])
            .then(([campaignRes, espRes]: any[]) => {
                if (campaignRes.status === 200 && campaignRes.data.success === true) {
                    const espAllData: any[] = espRes?.data?.data ?? [];
                    const mapped = campaignRes.data.data.map((item: any) => {
                        const match = espAllData.find((e: any) => String(e.id) === String(item.espConnectionId));
                        return {
                            ...item,
                            id: item.espConnectionId,
                            connectionName: match?.connectionName ?? item.espDomainName,
                            domain: item.espDomainName,
                        };
                    });
                    setESPConnectionData(mapped);
                }
            }).catch((error: any) => console.log("Error: ", error));
        getAllBrand(ClientId)
            .then(
                (res: BrandApiResponse1) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const brandArr: BrandApiResponse1[] = [];
                            res.data.data.map((brand: any) => {
                                brand.Name = `${brand.clientName}`
                                brandArr.push(brand)
                            })
                            setBrands(brandArr)
                        } else {
                            setBrands([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )


        // getAllGroup(ClientId)
        //     .then(
        //         (res: GroupApiResponse) => {
        //             if (res.status === 200) {
        //                 if (res.data.result === 1) {
        //                     const webhookArr: GroupListPropType[] = res.data.data.map((webhook: any) => ({
        //                         ...webhook, // Keep existing properties
        //                         Name: webhook.clientName, // Assign Name from clientName
        //                         cooldownPeriod: webhook.cooldownPeriod, // Ensure cooldownPeriod is assigned correctly
        //                     }));  
        //                     setGroups(webhookArr)
        //                 } else {
        //                     setGroups([])
        //                 }
        //             }
        //         }
        //     )
        //     .catch(
        //         (error: any) => console.log("Error: ", error)
        //     )

        

    }, [user])



    const handleSubmitClick = (): void => {
        console.log("Submit")
    }

    const onSubmit = async (data: NewCampaignInputs): Promise<void> => {
        setIsLoading(true)

        data.campaignId = campaignData.campaignId;
        data.updatedBy = user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;

        // Convert startOn and endOn to Moment for validation
        const startDate = moment(data.startOn);
        const endDate = moment(data.endOn);

        // Check if endDate is earlier than startDate
        if (endDate.isBefore(startDate)) {
            NotificationManager.error('End date must be after start date', '', 5000);
            setIsLoading(false);
            return;
        }

        data.startOn = moment(data.startOn).format('YYYY-MM-DD');
        data.endOn = moment(data.endOn).format('YYYY-MM-DD');
        data.hourlyMaxSendCount = 0;
        data.dailyMaxSendCount = 0;
        (data as any).brandId = data.brandId ?? null;
        (data as any).groupId = data.groupId ?? null;
        (data as any).espConnectionId = data.espConnectionId || null;
        (data as any).espDomain = data.espDomain ?? null;
        data.unopenedResendDayGap = data.unopenedResendDayGap ? data.unopenedResendDayGap : 0;
        data.unsubscribeTypeId = "2";
        const suppressionIds = getValues("suppressionListId");
        if (Array.isArray(suppressionIds) && suppressionIds.length > 0) {
            data.suppressionListId = suppressionIds.join(","); 
        } else {
            data.suppressionListId = null; 
        }
        try {
            console.log(data)

            const res = await updateNewCampaign(data);
            if (res.status === 200) {
                if (res.data.result === 1) {
                    // NotificationManager.success('Campaign updated successfully');
                    // refreshPage();
                    navigate(`/campaigns/summary/edit/${campaignData.campaignId}`)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('A campaign with the same name already exists for this client') ? 'Campaign name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error('Error occurred:', error);
            NotificationManager.error('Unknown error has occurred');
        } finally {
            setIsLoading(false);
        }
    }

    const handleCancel = (): void => {
        navigate('/campaigns')
    }

    // Handle group selection
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleGroupChange = (event: any, value: GroupListPropType | null) => {
        setSelectedGroup(value);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (value && value.cooldownPeriod !== undefined && value.cooldownPeriod !== null) {
            // If the selected group has a cooldown period, use it and disable the input field
            setCooldownPeriod(value.cooldownPeriod);
            setValue('doNotRepeatEmailDays', value.cooldownPeriod);
            setIsCooldownDisabled(true); // Disable the input field
        } else {
            // If the selected group does not have a cooldown period, set a default value and enable the input field
            setCooldownPeriod(0);
            setValue('doNotRepeatEmailDays', 0); // Default value
            setIsCooldownDisabled(false); // Enable the input field
        }
    };

    const handleUpdateCampaignConfirm = async (): Promise<void> => {
        setIsModalSaveLoading(true);
        try {
            const latestFormValues = getValues();

            const updatedData = {
            ...latestFormValues,
            campaignId: campaignData?.campaignId,
            clientId: user?.clientId ?? 0,
            updatedBy: user?.id ?? 0,
            };

            await onSubmit(updatedData);
            setShowUpdateCampaignModal(false);
        } 
        catch (error) {
            console.error('Error in confirmation update:', error);
        } 
        finally {
            setIsModalSaveLoading(false);
        }
    };

    const handleOpenUpdateCampaignModal = async (): Promise<void> => {
    const isValid = await trigger();
    if (!isValid) return;
    const isAdminUser = !!checkEventPermission('CAMPAIGN_EDIT_ACTIVE');
    const latestFormValues: NewCampaignInputs = getValues();

    const updatedData = {
        ...latestFormValues,
        campaignId: campaignData?.campaignId,
        clientId: user?.clientId ?? 0,
        updatedBy: user?.id ?? 0,
    };

        if (isAdminUser && campaignData?.isActive === true) {
            // Show confirmation modal for admin users
            setShowUpdateCampaignModal(true);
        } 
        else {
            // Direct update for other users
            await onSubmit(updatedData);
        }
    };

    const handleUpdateCampaignClose = (): void => {
        setShowUpdateCampaignModal(false);
    }
    
    return (
        <>          
                <div className="flex justify-between items-center">
                    <div className="w-full">
                        <div>
                            <h1 className="text-2xl text-title font-semibold">Edit Trigger Email</h1>
                            <Box sx={{ flexGrow: 1 }}>
                                <div className='campaign-form-container'>
                                    <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            void handleSubmit(onSubmit)(e);
                                                        }}
                                                    >
                                    <Grid container spacing={2}>
                                        <Grid item xs={8} sx={{ paddingRight: '20px' }}>
                                            {
                                                isDataLoading ?
                                                    <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :

                                                    <React.Fragment>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="name"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label='Campaign Name*'
                                                                                    // placeholder="Campaign Name"
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <BootstrapTooltip title={CAMPAIGN_NAME_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                <InputAdornment position="end" >
                                                                                                    <HugeiconsIcon
                                                                                                        icon={HelpCircleIcon}
                                                                                                        size={18}
                                                                                                        color="#3A3A3A"
                                                                                                        strokeWidth={0.2}
                                                                                                    />

                                                                                                </InputAdornment>
                                                                                            </BootstrapTooltip>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.name)}
                                                                                />
                                                                                {errors.name && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.name?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="startOn"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <div className="datepicker-container">
                                                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                                        <DemoContainer components={['DatePicker']}>
                                                                                            <DatePicker
                                                                                                label="Campaign Start Date*"
                                                                                                value={field.value ? moment(field.value, "MM/DD/YYYY") : null} // Parse the string into a moment object
                                                                                                dayOfWeekFormatter={(day) => day.format('ddd')}
                                                                                                onChange={(newValue) => {
                                                                                                    if (newValue && moment(newValue).isValid()) {
                                                                                                        // Convert the moment object to a string in "MM/DD/YYYY" format
                                                                                                        field.onChange(newValue.format("MM/DD/YYYY"));
                                                                                                    } else {
                                                                                                        // Pass an empty string or null to trigger required validation
                                                                                                        field.onChange("");
                                                                                                    }
                                                                                                }}
                                                                                                shouldDisableDate={(date) => date.isBefore(moment(), 'day')}
                                                                                                format="MM/DD/YYYY"
                                                                                                slotProps={{
                                                                                                    textField: {
                                                                                                        error: Boolean(errors.startOn),
                                                                                                        helperText: errors.startOn ? (
                                                                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                                <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
                                                                                                                {errors.startOn.message}
                                                                                                            </span>
                                                                                                        ) : '',
                                                                                                    },
                                                                                                }}
                                                                                                slots={{
                                                                                                    openPickerIcon: () => (
                                                                                                        <HugeiconsIcon
                                                                                                            icon={Calendar03Icon}
                                                                                                            size={18}
                                                                                                            color="#3A3A3A"
                                                                                                            strokeWidth={0.5}
                                                                                                        />
                                                                                                    )
                                                                                                }}
                                                                                            />
                                                                                        </DemoContainer>
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="endOn"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <div className='datepicker-container'>
                                                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                                        <DemoContainer components={['DatePicker']}>
                                                                                            <DatePicker
                                                                                                label="Campaign End Date*"
                                                                                                value={field.value ? moment(field.value, "MM/DD/YYYY") : null} // Parse the string into a moment object
                                                                                                dayOfWeekFormatter={(day) => day.format('ddd')}
                                                                                                onChange={(newValue) => {
                                                                                                    if (newValue && moment(newValue).isValid()) {
                                                                                                        // Convert the moment object to a string in "MM/DD/YYYY" format
                                                                                                        field.onChange(newValue.format("MM/DD/YYYY"));
                                                                                                    } else {
                                                                                                        // Pass an empty string or null to trigger required validation
                                                                                                        field.onChange("");
                                                                                                    }
                                                                                                }}
                                                                                                shouldDisableDate={(date) => date.isBefore(moment(), 'day')}
                                                                                                format="MM/DD/YYYY"
                                                                                                slotProps={{
                                                                                                    textField: {
                                                                                                        error: Boolean(errors.endOn),
                                                                                                        helperText: errors.endOn ? (
                                                                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                                <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
                                                                                                                {errors.endOn.message}
                                                                                                            </span>
                                                                                                        ) : '',
                                                                                                    },
                                                                                                }}
                                                                                                slots={{
                                                                                                    openPickerIcon: () => (
                                                                                                        <HugeiconsIcon
                                                                                                            icon={Calendar03Icon}
                                                                                                            size={18}
                                                                                                            color="#3A3A3A"
                                                                                                            strokeWidth={0.5}
                                                                                                        />
                                                                                                    )
                                                                                                }}
                                                                                            />
                                                                                        </DemoContainer>
                                                                                    </LocalizationProvider>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="brandId"
                                                                        control={control}
                                                                        defaultValue={campaignData?.brandId}
                                                                        render={({ field }) => (

                                                                            <Autocomplete
                                                                                options={brands} // The list of roles
                                                                                getOptionLabel={(option: any) => option.brandName} // Display roleName
                                                                                popupIcon={
                                                                                    <HugeiconsIcon
                                                                                        icon={ArrowDown01Icon}
                                                                                        size={18}
                                                                                        color="#3A3A3A"
                                                                                        strokeWidth={0.5}

                                                                                    />
                                                                                }
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                isOptionEqualToValue={(option, value) => option.id == value.brandId} // Match by roleId
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                value={brands.find((brand) => brand.id === field.value) || null}
                                                                                // value={brands.find((brand: BrandListPropType) => brand.id == field.value) || null} // Current value matching
                                                                                onChange={(_, selectedBrand) => {
                                                                                    const id = selectedBrand?.id; // Handle null cases
                                                                                    field.onChange(id); // Update form state
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <>
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label="Brand"
                                                                                            // placeholder="Select Brand"
                                                                                            InputProps={{
                                                                                                ...params.InputProps,
                                                                                                endAdornment: (
                                                                                                    <React.Fragment>
                                                                                                        
                                                                                                        {/* Position the clear icon before the tooltip */}
                                                                                                        {params.InputProps.endAdornment && (
                                                                                                            <InputAdornment position="end" sx={{ position: 'absolute', right: '40px' }}>
                                                                                                            {params.InputProps.endAdornment}
                                                                                                            </InputAdornment>
                                                                                                        )}
                                                                                                        <BootstrapTooltip title= {BRAND_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                            <InputAdornment position="end" sx={{ position: 'absolute', right: '13px' }}>

                                                                                                                <HugeiconsIcon
                                                                                                                    icon={HelpCircleIcon}
                                                                                                                    size={18}
                                                                                                                    color="#3A3A3A"
                                                                                                                    strokeWidth={0.2}
                                                                                                                />

                                                                                                            </InputAdornment>
                                                                                                        </BootstrapTooltip>
                                                                                                    </React.Fragment>
                                                                                                ),
                                                                                            }}
                                                                                            error={Boolean(errors.brandId)}
                                                                                        />
                                                                                        {errors.brandId && (
                                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                                {errors.groupId?.message} {/* Show the error message */}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="groupId"
                                                                        control={control}
                                                                        defaultValue={campaignData?.groupId}
                                                                        render={({ field }) => (

                                                                            <Autocomplete
                                                                                options={groups} // The list of roles
                                                                                getOptionLabel={(option: any) => option.groupName} // Display roleName
                                                                                popupIcon={
                                                                                    <HugeiconsIcon
                                                                                        icon={ArrowDown01Icon}
                                                                                        size={18}
                                                                                        color="#3A3A3A"
                                                                                        strokeWidth={0.5}

                                                                                    />
                                                                                }
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                isOptionEqualToValue={(option, value) => option.id === value.groupId} // Match by roleId
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                value={groups.find((group) => group.id === field.value) || null}
                                                                                // value={groups.find((group: GroupListPropType) => group.id.toString() === field.value)} // Current value matching
                                                                                onChange={(_, selectedGroup) => {
                                                                                    const id = selectedGroup?.id;
                                                                                    field.onChange(id);
                                                                                    handleGroupChange(_, selectedGroup);
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <>
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label="Group"
                                                                                            // placeholder="Select Group"
                                                                                            InputProps={{
                                                                                                ...params.InputProps,
                                                                                                endAdornment: (
                                                                                                    <React.Fragment>
                                                                                                        {/* Position the clear icon before the tooltip */}
                                                                                                        {params.InputProps.endAdornment && (
                                                                                                            <InputAdornment position="end" sx={{ position: 'absolute', right: '40px' }}>
                                                                                                            {params.InputProps.endAdornment}
                                                                                                            </InputAdornment>
                                                                                                        )}

                                                                                                        <BootstrapTooltip title={GROUP_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                            <InputAdornment position="end" sx={{ position: 'absolute', right: '13px' }}>

                                                                                                                <HugeiconsIcon
                                                                                                                    icon={HelpCircleIcon}
                                                                                                                    size={18}
                                                                                                                    color="#3A3A3A"
                                                                                                                    strokeWidth={0.2}
                                                                                                                />

                                                                                                            </InputAdornment>
                                                                                                        </BootstrapTooltip>
                                                                                                    </React.Fragment>
                                                                                                ),
                                                                                            }}
                                                                                            error={Boolean(errors.groupId)}
                                                                                        />
                                                                                        {errors.groupId && (
                                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                                {errors.groupId?.message} {/* Show the error message */}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="templateId"
                                                                        control={control}
                                                                        defaultValue={campaignData?.templateId}
                                                                        render={({ field }) => (

                                                                            <Autocomplete
                                                                                options={emailTemplates} // The list of roles
                                                                                getOptionLabel={(option: any) => option.templateName} // Display roleName
                                                                                popupIcon={
                                                                                    <HugeiconsIcon
                                                                                        icon={ArrowDown01Icon}
                                                                                        size={18}
                                                                                        color="#3A3A3A"
                                                                                        strokeWidth={0.5}

                                                                                    />
                                                                                }
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                isOptionEqualToValue={(option, value) => option.id === value.templateId} // Match by roleId
                                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                                //@ts-ignore
                                                                                value={emailTemplates.find((emailTemplate) => emailTemplate.id === field.value) || null}
                                                                                // value={emailTemplates.find((emailTemplate: TemplateListPropType) => emailTemplate.id.toString() === field.value)} // Current value matching
                                                                                onChange={(_, selectedTemplate) => {
                                                                                    const id = selectedTemplate?.id; // Handle null cases
                                                                                    field.onChange(id); // Update form state
                                                                                    setSelectedTemplate(selectedTemplate);
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <>
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label="Email Template*"
                                                                                            // placeholder="Select Email template"
                                                                                            error={Boolean(errors.templateId)}
                                                                                        />
                                                                                        {errors.templateId && (
                                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                                {errors.templateId?.message} {/* Show the error message */}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                                disableClearable // Prevent the clear button
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="espConnectionId"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <Autocomplete
                                                                                    options={espConnectionData}
                                                                                    getOptionLabel={(option: any) => option?.domain ?? ""}
                                                                                    popupIcon={
                                                                                        <HugeiconsIcon
                                                                                            icon={ArrowDown01Icon}
                                                                                            size={18}
                                                                                            color="#3A3A3A"
                                                                                            strokeWidth={0.5}
                                                                                        />
                                                                                    }
                                                                                    //@ts-ignore
                                                                                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                                                    value={espConnectionData.find((esp: any) => esp.id.toString() === field.value) ?? null}
                                                                                    onChange={(_, selectedConnection: any) => {
                                                                                        field.onChange(selectedConnection ? selectedConnection.id.toString() : "");
                                                                                        setValue("espDomain", selectedConnection ? selectedConnection.domain : null);
                                                                                    }}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label="Domain Name*"
                                                                                            placeholder="Select domain name"
                                                                                            error={Boolean(errors.espConnectionId)}
                                                                                            inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                                {errors.espConnectionId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="esp" width={12} height={12} className="mr-1" />
                                                                                        {errors.espConnectionId?.message}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        {/* <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                <Controller
                                                                    name="unsubscribeTypeId"
                                                                    control={control}
                                                                    defaultValue={campaignData?.unsubscribeTypeId || ""} 
                                                                    render={({ field }) => (
                                                                    <Autocomplete
                                                                        options={UNSUBSCRIBE_LEVELS}
                                                                        getOptionLabel={(option: any) => option.label} 
                                                                        popupIcon={
                                                                        <HugeiconsIcon
                                                                            icon={ArrowDown01Icon}
                                                                            size={18}
                                                                            color="#3A3A3A"
                                                                            strokeWidth={0.5}
                                                                        />
                                                                        }
                                                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                                        value={ UNSUBSCRIBE_LEVELS.find((level) => level.value === field.value) ?? undefined
                                                                        }
                                                                        onChange={(_, selectedLevel) => {
                                                                        field.onChange(selectedLevel?.value || ""); 
                                                                        }}
                                                                        renderInput={(params) => (
                                                                        <>
                                                                            <TextField
                                                                            {...params}
                                                                            label="Unsubscribe Level*"
                                                                            error={Boolean(errors.unsubscribeTypeId)}
                                                                            />
                                                                            {errors.unsubscribeTypeId && (
                                                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1"/>
                                                                                {errors.unsubscribeTypeId?.message}
                                                                            </div>
                                                                            )}
                                                                        </>
                                                                        )}
                                                                        disableClearable
                                                                    />
                                                                    )}
                                                                />
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="suppressionListId"
                                                                        control={control}
                                                                        defaultValue={[]} 
                                                                        render={({ field }) => {
                                                                            const selected = suppressionList.filter((s) =>
                                                                                (field.value ?? []).includes(String(s.suppressionListId))
                                                                            );

                                                                            return (
                                                                            <Autocomplete
                                                                                multiple
                                                                                options={suppressionList}
                                                                                disableCloseOnSelect
                                                                                value={selected}
                                                                                getOptionLabel={(option: any) => option.title}
                                                                                isOptionEqualToValue={(option, value) =>
                                                                                String(option.suppressionListId) === String(value.suppressionListId)
                                                                                }
                                                                                onChange={(_, selectedLists) => {
                                                                                    const ids = selectedLists.map((s) => String(s.suppressionListId));
                                                                                    field.onChange(ids);
                                                                                }}

                                                                                renderTags={(tagValue, getTagProps) => (
                                                                                <>
                                                                                    {tagValue.slice(0, 2).map((option, index) => {
                                                                                    const { key, ...tagProps } = getTagProps({ index });
                                                                                    return (
                                                                                        <Chip
                                                                                        key={option.suppressionListId}
                                                                                        label={option.title}
                                                                                        {...tagProps}
                                                                                        size="small"
                                                                                        />
                                                                                    );
                                                                                    })}
                                                                                    {tagValue.length > 2 && (
                                                                                    <span style={{ marginLeft: 8, color: "#666" }}>
                                                                                        +{tagValue.length - 2}
                                                                                    </span>
                                                                                    )}
                                                                                </>
                                                                                )}
                                                                                popupIcon={
                                                                                <HugeiconsIcon
                                                                                    icon={ArrowDown01Icon}
                                                                                    size={18}
                                                                                    color="#3A3A3A"
                                                                                    strokeWidth={0.5}
                                                                                />
                                                                                }
                                                                                renderOption={(props, option, { selected }) => (
                                                                                <li {...props}>
                                                                                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                                                                    {option.title}
                                                                                </li>
                                                                                )}
                                                                                renderInput={(params) => (
                                                                                <>
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label="Suppression Lists"
                                                                                        error={Boolean(errors.suppressionListId)}
                                                                                    />
                                                                                    {errors.suppressionListId && (
                                                                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                            <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1"/>
                                                                                            {errors.suppressionListId?.message}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                                )}
                                                                            />
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid> */}
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={4}>
                                                                <div className="mb-[0px]">
                                                                    <Controller
                                                                        name="resendMaxLimit"
                                                                        control={control}
                                                                        defaultValue={ResendDefaultValue ? parseInt(ResendDefaultValue, 10) : 1}
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label='Maximum Resends'
                                                                                    // placeholder="Maximum Resends"
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <BootstrapTooltip title={MAXIMUM_RESEND_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                <InputAdornment position="end" >

                                                                                                    <HugeiconsIcon
                                                                                                        icon={HelpCircleIcon}
                                                                                                        size={18}
                                                                                                        color="#3A3A3A"
                                                                                                        strokeWidth={0.2}
                                                                                                    />

                                                                                                </InputAdornment>
                                                                                            </BootstrapTooltip>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.resendMaxLimit)}
                                                                                />
                                                                                {errors.resendMaxLimit && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.resendMaxLimit?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <div className="mb-[0px]">
                                                                    <Controller
                                                                        name="unopenedResendDayGap"
                                                                        control={control}
                                                                        defaultValue={ResendDefaultInterval ? parseInt(ResendDefaultInterval, 10) : 5}
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label='Resends Interval (days)'
                                                                                    // placeholder="Resends Interval (days)"
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <BootstrapTooltip title={RESEND_INTERVAL_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                <InputAdornment position="end" >

                                                                                                    <HugeiconsIcon
                                                                                                        icon={HelpCircleIcon}
                                                                                                        size={18}
                                                                                                        color="#3A3A3A"
                                                                                                        strokeWidth={0.2}
                                                                                                    />

                                                                                                </InputAdornment>
                                                                                            </BootstrapTooltip>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.unopenedResendDayGap)}
                                                                                />
                                                                                {errors.unopenedResendDayGap && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.unopenedResendDayGap?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <div className="mb-[0px]">
                                                                    <Controller
                                                                        name="doNotRepeatEmailDays"
                                                                        control={control}
                                                                        defaultValue={CooldownDefaultPeriod ? parseInt(CooldownDefaultPeriod, 10) : 30}
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label='Cooldown Period (days)'
                                                                                    // placeholder="Cooldown Period (days)"
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <BootstrapTooltip title={COOLDOWN_PERIOD_TOOLTIP_MESSAGE} sx={{ cursor: 'pointer' }}>
                                                                                                <InputAdornment position="end" >

                                                                                                    <HugeiconsIcon
                                                                                                        icon={HelpCircleIcon}
                                                                                                        size={18}
                                                                                                        color="#3A3A3A"
                                                                                                        strokeWidth={0.2}
                                                                                                    />

                                                                                                </InputAdornment>
                                                                                            </BootstrapTooltip>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.doNotRepeatEmailDays)}
                                                                                    disabled={isCooldownDisabled}
                                                                                />
                                                                                {errors.doNotRepeatEmailDays && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                        {errors.doNotRepeatEmailDays?.message} {/* Show the error message */}
                                                                                    </div>
                                                                                )}
                                                                            </>

                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="clientCampaignId"
                                                                        control={control}
                                                                        defaultValue={campaignData?.clientCampaignId || ""}
                                                                        render={({ field }) => (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label='Client Campaign ID'
                                                                                    InputProps={{
                                                                                        endAdornment: (
                                                                                            <BootstrapTooltip title={BULK_CLIENT_CAMPAIGN_ID} sx={{ cursor: 'pointer' }}>
                                                                                                <InputAdornment position="end" >
                                                                                                    <HugeiconsIcon
                                                                                                        icon={HelpCircleIcon}
                                                                                                        size={18}
                                                                                                        color="#3A3A3A"
                                                                                                        strokeWidth={0.2}
                                                                                                    />
                                                                                                </InputAdornment>
                                                                                            </BootstrapTooltip>
                                                                                        ),
                                                                                    }}
                                                                                    error={Boolean(errors.clientCampaignId)}
                                                                                />
                                                                                {errors.clientCampaignId && (
                                                                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                        <img src="/assets/images/attention.svg" alt="clientCampaignId" width={12} height={12} className="mr-1" />
                                                                                        {errors.clientCampaignId?.message}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        
                                                        </React.Fragment>
                                            }
                                        </Grid>
                                        <Grid item xs={4} sx={{ paddingLeft: '20px' }}>
                                            <div className='flex justify-start items-center gap-2 mt-[-13px] mb-[5px]'>
                                                <div className='text-16 font-semibold text-muted'>Template Preview</div>
                                                {( checkEventPermission('CAMPAIGN_SEND_TEST_EMAIL') && campaignData?.isActive ) &&
                                                    // <div className='text-14 font-[600] text-red cursor-pointer' onClick={() => setTestEmailModalOpen(true)}>Send Test Email</div>
                                                    <div className="icon-hover-container">
                                                        <BootstrapTooltip title={SEND_TEST_EMAIL}>
                                                          <IconButton onClick={() => setTestEmailModalOpen(true)}>
                                                            <HugeiconsIcon
                                                              icon={MailSend02Icon}
                                                              size={24}
                                                              strokeWidth={0.2}
                                                              color="#3a3a3a"
                                                            />
                                                          </IconButton>
                                                        </BootstrapTooltip>
                                                      </div>
                                                }
                                            </div>
                                            <div className="relative cursor-pointer flex justify-center items-center h-[345px] border border-[#e6ecf2] rounded-lg" onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}>
                                                 
                                                                  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
                                                                    {!imageError ? (
                                                                      <img
                                                                        src={`${TemplateImagePublicURL}Template/${selectedTemplate?.templateIdentifier}/${selectedTemplate?.templateVersion}/Template_Large.png`}
                                                                        alt="Template Preview"
                                                                        className="icon-hover"
                                                                        onError={() => setImageError(true)}
                                                                         style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                                      />
                                                                    ) : (
                                                                      <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                                                                    )}
                                                                  </div>
                                                             
                                             <div
                                                               className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${
                                                                 selectedTemplate?.templateIdentifier
                                                                   ? 'hover:opacity-100 transition-opacity cursor-pointer'
                                                                   : ''
                                                               }`}
                                                               onClick={
                                                                 selectedTemplate?.templateContent
                                                                   ? () => setPreviewContent(selectedTemplate.templateContent)
                                                                   : undefined
                                                               }
                                                             >
                                                               <HugeiconsIcon
                                                                 icon={ViewStrokeRounded}
                                                                 size={24}
                                                                 color="currentcolor"
                                                                 strokeWidth={0.5}
                                                                 className={`cursor-pointer text-white ${
                                                                   !selectedTemplate?.templateContent
                                                                     ? 'opacity-50 cursor-not-allowed'
                                                                     : ''
                                                                 }`}
                                                               />
                                                             </div>
                                               

                                                
                                            </div>
                                            {(campaignData?.createdOn || campaignData?.createdByName || campaignData?.updatedOn || campaignData?.updatedByName) && (
                                                <div className="mt-3 text-[14px] text-gray-700 space-y-1">
                                                    {(campaignData?.createdOn || campaignData?.createdByName) && (
                                                    <div>
                                                        <span className="font-semibold text-muted">Created:</span>{" "}
                                                        {campaignData?.createdOn && moment(campaignData.createdOn).format("MM/DD/YYYY h:mmA")}
                                                        {campaignData?.createdByName && (
                                                        <span className="italic text-gray-600"> ({campaignData.createdByName})</span>
                                                        )}
                                                    </div>
                                                    )}
                                                    {(campaignData?.updatedOn || campaignData?.updatedByName) && (
                                                    <div>
                                                        <span className="font-semibold text-muted">Last Updated:</span>{" "}
                                                        {campaignData?.updatedOn && moment(campaignData.updatedOn).format("MM/DD/YYYY h:mmA")}
                                                        {campaignData?.updatedByName && (
                                                        <span className="italic text-gray-600"> ({campaignData.updatedByName})</span>
                                                        )}
                                                    </div>
                                                    )}
                                                </div>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <TemplatePreview
                                        isOpen={isPreviewModalOpen}
                                        onClose={() => setIsPreviewModalOpen(false)}
                                        content={selectedTemplate?.templateContent ?? ''}
                                    />
                                    <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />
                                                        <div className='flex justify-between items-center gap-x-3.5'>
                                                            <OutlineButton color='gray' onClick={handleCancel} disabled={isLoading}>Cancel</OutlineButton>
                                                            <BootstrapTooltip
                                                                title={isDisabled ? CAMPAIGN_EDITING_DISABLED_MESSAGE: ""}>
                                                                <span> 
                                                                    <GradientButton
                                                                        type="button"
                                                                        color="red"
                                                                        onClick={() => { void handleOpenUpdateCampaignModal(); }}
                                                                        disabled={ 
                                                                            isLoading ||
                                                                            isDisabled
                                                                          }
                                                                    >
                                                                        {!isLoading ? 'Update Trigger Email' : (
                                                                            <span className="loading loading-spinner loading-xs text-white"></span>
                                                                        )}
                                                                    </GradientButton>
                                                                </span>
                                                            </BootstrapTooltip>
                                                        </div>
                                    </form>
                                </div>
                            </Box>
                        </div>
                    </div>
                    <BootstrapDialog onClose={handleUpdateCampaignClose} aria-labelledby="customized-dialog-title" open={showUpdateCampaignModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                            Active Trigger Email Confirmation
                        </DialogTitle>
                        <IconButton aria-label="close" onClick={handleUpdateCampaignClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                            <HugeiconsIcon
                                icon={MultiplicationSignStrokeStandard}
                                size={24}
                                color="currentcolor"
                                strokeWidth={0.5}
                            />
                        </IconButton>
                        <DialogContent>
                            <p className='text-14 text-muted'>{'This campaign is currently active. Proceeding may impact the existing workflow. Do you want to continue?'}</p>
                        </DialogContent>
                        <DialogActions sx={{ background: '#F9F9F9' }}>
                            <OutlineButton color='gray' onClick={handleUpdateCampaignClose} width='100px'>No</OutlineButton>
                            <GradientButton type='button' color='red' onClick={() => { void handleUpdateCampaignConfirm(); }} width='100px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                        </DialogActions>
                    </BootstrapDialog>
                </div>
            <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} Type={"Campaign"} TypeId={id as unknown as number} TemplateId={campaignData?.templateId} />
        </>
    )
}

export default EditCampaing